export const HTTP_OK = 200;
export const HTTP_NOT_OK = 300;
export const HTTP_UNAUTHORIZED = 401;
export const HTTP_FORBIDDEN = 403;
export const HTTP_NOT_FOUND = 404;
export const HTTP_CLIENT_TIMEOUT = 408;
export const HTTP_UNPROCESSABLE_ENTITY = 422;

export const HTTP_INTERNAL_SERVER_ERROR = 500;
export const HTTP_SERVER_TIMEOUT = 504;

export const API_UNAUTHORIZED = 'API_UNAUTHORIZED';
export const API_FORBIDDEN = 'API_FORBIDDEN';
